<template>
    <q-page class="q-pa-md">
        <trading-items ref="tradingItems"></trading-items>
    </q-page>
</template>

<script>
    export { default } from './skumapapplicationviewmodel-custom-screen.js'
</script>